import { ViewerSelect as CompViewerSelect } from '@/components/ViewerSelect';
import { r2wc } from '@/wc/helper/render';

export const ViewerSelect = r2wc(CompViewerSelect, {
  shadow: 'open',
  props: {
    selectedItems: 'json',
    defaultOptions: 'json',
    // NOTE: The container is set automatically by r2wc and should be of the appropriate type.
    container: 'string',
  },
});
